import React from "react";
import { Box, Typography } from "@mui/material";

const NumberCircle = ({
  number,
  color = "#1890ff", // default color
  size = { xs: "18vw", sm: "8vw", md: "70px" }, // responsive
  borderWidth = 6,
  fontSize = { xs: "1.2rem", sm: "1.5rem", md: "2rem" },
}) => (
  <Box
    sx={{
      width: size,
      height: size,
      borderRadius: "50%",
      border: `${borderWidth}px solid ${color}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#fff",
      boxSizing: "border-box",
      mx: "auto",
      aspectRatio: "1 / 1", // keeps it a perfect circle
    }}
  >
    <Typography sx={{ fontWeight: "bold", fontSize, color: "#222" }}>
      {number}
    </Typography>
  </Box>
);

export default NumberCircle;
